import { Injectable } from '@angular/core';

import { AppConfig } from './app-config.service';
import { LocalStorage } from '../client/helpers/local-storage';

import { environment } from '../../../environments/environment';

@Injectable()
export class ParentEvents {
    public isClientPortal = environment.portalClient;

    constructor(private localStorage: LocalStorage) {}

    cancel(isContract = false) {
        if (this.isClientPortal) {
            const form = document.createElement('form');
            form.setAttribute('method', 'post');
            form.setAttribute('action', AppConfig.settings.portalClientUrl + '/Portfolio/Contracts');
            form.setAttribute('target', '_self');

            form.appendChild(this.createInputElement('Language', this.localStorage.language));
            form.appendChild(this.createInputElement('Domain', this.localStorage.domain));
            form.appendChild(this.createInputElement('SessionToken', this.localStorage.sessionToken));
            form.appendChild(this.createInputElement('ClientCode', this.localStorage.clientCode));
            form.appendChild(this.createInputElement('IsEnableAccount', 'true'));
            form.appendChild(this.createInputElement('DecimalSeparator', ','));
            form.appendChild(this.createInputElement('NumberOfDecimals', '2'));
            form.appendChild(this.createInputElement('GroupSeparator', '.'));
            form.appendChild(this.createInputElement('NegativeSymbol', '-'));
            form.appendChild(this.createInputElement('DateFormat', 'DD-MM-YYYY'));
            form.appendChild(
                this.createInputElement(
                    'ConditionalFormats',
                    '[{"AssetTypes":"8,A,ACE,ACI,ACN,B,BN,BOC,C,CHI,CHN,CP0,CPC,CUS,DCA,DEE,DEI,DEL,DEX,DIV,DOP,DPE,DPN,' +
                        'DPS,DSE,DSU,EFA,EFE,EFI,EPS,ETC,ETF,ETN,EUR,F,FAC,FBA,FBN,FDI,FDX,FEX,FG,FGL,FGM,FGX,FGZ,FIN,FIX,FMI,FMN,FMP,FSX,FTI,GR,I,IIA,IIE,IIF,III,IIN,IIO,IND,LTR,M,MP,N,OAC,OBU,' +
                        'ODI,OIN,OIX,OMI,OMN,OTC,PAG,PCA,PPF,PPI,PPN,PPT,PRS,R,REC,REN,RFA,RFB,RFC,RFN,RL,RVR,S,SCV,SPR,TI,W,WAR,WE,X,","Currencies":"AED,ARS,AUD,BGN,BMD,BRL,BSD,CAD,CHF,CLF,CLP,' +
                        'CNY,CZK,DKK,EEK,EGP,EUR,GBP,HKD,HRK,HUF,IDR,ILS,INR,ISK,JPY,KES,KRW,KZD,LTL,LVL,MAD,MXN,MYR,NOK,NZD,PAB,PEN,PLN,ROL,RUB,SAR,SEK,SGD,SKK,THB,TRL,TRY,TWD,UAH,USc,USD,ZAR,"' +
                        ',"PriceDecimalNumber":2,"PricePattern":"#,0.00","ValuationDecimalNumber":2,"ValuationPattern":"#,0.00"}]'
                )
            );
            form.appendChild(this.createInputElement('PeriodExpiration', 'Y'));
            form.appendChild(this.createInputElement('ExpirationUnits', '1'));

            document.body.append(form);
            form.submit();
        } else if (window.parent) {
            let eventName = 'Onboarding_Redirect';
            if (isContract) {
                eventName = 'Onboarding_Redirect_ProfilePortfolio';
            }

            const event = new Event(eventName, { bubbles: true, cancelable: true });
            window.parent.document.dispatchEvent(event);
        }

    }

    private createInputElement(name: string, value: string): HTMLElement {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;

        return input;
    }

    logout() {
        if (window.parent) {
            const event = new Event('Onboarding_redirectToLogin', { bubbles: true, cancelable: true });

            window.parent.document.dispatchEvent(event);
        }
    }

    reset() {
        if (window.parent) {
            const event = new Event('resetTimer', { bubbles: true, cancelable: true });

            window.parent.document.dispatchEvent(event);
        }
    }

    resize() {
        setTimeout(() => {
            if (window.parent) {
                const event = new Event('resizeTower30Iframe', { bubbles: true, cancelable: true });

                window.parent.document.dispatchEvent(event);
            }
        }, 300);
    }

    resizeLoyalty() {
        if (window.parent) {
            const event = new Event('ResizeToLogalty', { bubbles: true, cancelable: true });

            window.parent.document.dispatchEvent(event);
        }
    }
    scrollUp() {
        setTimeout(() => {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            window.scrollTo({ top: 0, behavior: 'smooth' });

            if (window.parent) {
                window.parent.document.body.scrollTop = 0;
                window.parent.document.documentElement.scrollTop = 0;
                window.parent.scrollTo({ top: 0, behavior: 'smooth' });

                const event = new Event('ScrollUpTower30Iframe', { bubbles: true, cancelable: true });
                window.parent.document.dispatchEvent(event);
            }
        }, 400);
    }
}
